export default {
  setFreeTrialEndPeriod({ commit }, payload) {
    commit('SET_FREE_TRIAL_END_PERIOD', payload);
  },
  setAssignee({ commit }, payload) {
    commit('SET_ASSIGNEE', payload);
  },
};
